import React from "react";
import { Group, Text, Box, Checkbox } from '@mantine/core';

const BarangFormCekDetilDibatalkan = ({ stateData }) => {

    return (
        <React.Fragment>
            <Group
                position="apart"
                noWrap
                align='flex-start'
            >
                <Box>
                    <Checkbox
                        checked={Boolean(Number(stateData.is_check_nota))}
                        readOnly
                        size='xs'
                        label={
                            <Group align="center" spacing={8}>
                                {stateData.barang_form_cek_detil_name}
                            </Group>
                        }
                    />

                    {stateData.keterangan_nota &&
                        <Text size='sm' mt='xs' ml='1.75rem'>
                            {stateData.keterangan_nota}
                        </Text>
                    }
                </Box>
            </Group>
        </React.Fragment>
    )
}

export default BarangFormCekDetilDibatalkan;